import Box, { type BoxProps } from '@components/Box';
import { cssMerge } from '@shared/util';
import { forwardRef } from 'react';

type Props = BoxProps & {
  size?: 'small' | 'medium';
};

const Skeleton = forwardRef<HTMLDivElement, Props>(
  (
    { children, className, size = 'medium', width = 'full', ...restProps },
    ref,
  ) => (
    <Box
      ref={ref}
      {...restProps}
      className={cssMerge(
        'skeleton',
        `w-${width}`,
        size === 'small' && 'micro',
        className,
      )}
    >
      {children}
    </Box>
  ),
);

Skeleton.displayName = 'Skeleton';

export default Skeleton;
